<template>
  <v-dialog
    v-model="dialogModel"
    :width="dialogParams.width"
    style="z-index:1002"
  >
    <ui-dialog
      :title="dialogParams.title"
      :picture="dialogParams.icon"
      class="gift-dialog"
      @close="dialogModel = false"
      v-if="dialogModel"
    >
      <div
        class="gift-dialog_form"
        v-if="!formSended"
      >
        <gift-form
          @sendSuccess="sendSuccessHandler"
        />
      </div>
    </ui-dialog>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationRules } from '@/helpers/ValidationRules.js'
import GiftForm from '@/components/GiftForm.vue'
export default {
  name: `gift-dialog`,

  components: {
    GiftForm,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: `value`,
    event: `close`,
  },

  data: () => ({
    dialogParams: {
      title: `Дарите близким отдых!`,
      icon: `img/misc/gift-pic.svg`,
      width: `998`,
    },
    formSended: false,
  }),

  computed: {
    dialogModel: {
      get() {
        return this.value
      },
      set(v) {
        if(!v) {
          this.reset()
          this.$emit(`close`, false)
        }
      }
    }
  },

  methods: {
    sendSuccessHandler() {
      this.dialogParams = {
        title: `Подарок отправлен!`,
        icon: `img/misc/gift-success-pic.svg`,
        width: `570`,
      }
      this.formSended = true
      this.$emit(`sendSuccess`)
    },

    reset() {
      this.dialogParams = {
        title: `Дарите близким отдых!`,
        icon: `img/misc/gift-pic.svg`,
        width: `998`,
      }
      this.formSended = false
    }
  },
}
</script>

<style lang="sass">
.gift-dialog
  width: 100%

.gift-dialog_form
  width: 100%
  max-width: px-em(510)
  margin: 0 auto

.gift-dialog_text
  text-align: center
  margin-bottom: px-em(25)

.gift-dialog_guests-select
  margin-bottom: px-em(20)

.gift-dialog_guests-another
  width: 100%
  display: flex
  justify-content: center

.gift-dialog_another-fieldset
  flex-shrink: 0
  width: 100%
  background-color: rgba(255,250,228, .5)
  padding: px-em(25) px-em(20) px-em(30)
  margin: px-em(10) 0
  position: relative

.gift-dialog_another-cancel
  position: absolute
  top: px-em(15)
  right: px-em(15)

  .v-icon
    font-size: px-em(14) !important

  .v-icon__component
    width: 1em
    height: 1em

.gift-dialog_field
  position: relative

.gift-dialog_field-modify
  position: absolute
  top: 0
  right: 0

.gift-dialog_actions
  width: 100%
  display: flex
  justify-content: center
  margin-top: px-em(30)
</style>
